























































import Vue from "vue";
import Tooltip from "@/components/tooltip/Tooltip.vue";
import ActionIcon from "@/components/pps-actions-module/ActionIcon.vue";
import {formatPrice} from "@/filters/format-price";
import {Action, Header, Main, Tier} from "@/model/action";
import {Util} from "@/util/util";

export default Vue.extend({
    name: "HeuverAction",
    components: {
        Tooltip,
        ActionIcon
    },
    props: {
        action: {
            type: Object as () => Action,
            required: true
        },
        locale: {
            type: String,
            default: Util.getConfig().locale
        },
        aggregatedAmount: {
            type: Number,
            required: false,
            default: undefined
        },
        displayMode: {
            type: String,
            default: 'standard'
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        styleClass: {
            type: String,
            default: ''
        },
        iconType: {
            type: String,
            default: ''
        },
        iconSize: {
            type: String,
            default: 'small'
        }
    },
    computed: {
        standardMode(): boolean {
            return 'standard' === this.displayMode.toLowerCase();
        },
        sectionMode(): boolean {
            return 'section' === this.displayMode.toLowerCase();
        },
        ctaMode(): boolean {
            return 'cta' === this.displayMode.toLowerCase();
        },
        labelMode(): boolean {
            return 'label' === this.displayMode.toLowerCase();
        },
        iconMode(): boolean {
            return 'icon' === this.displayMode.toLowerCase();
        },
        staffelTiersMode(): boolean {
            return 'staffel-tiers' === this.displayMode.toLowerCase() && this.action.isQuantityDiscountType();
        },
        language(): string {
            //console.log('locale: ' + this.locale);
            if (this.locale) {
                return this.locale;
            }
            return 'en';
        },
        isPercentage(): boolean {
            return this.action.isPercentageDiscountType();
        },
        /**
         * Returns the header text for the domain of this component.
         */
        header(): string {
            const h: Header | undefined = this.action.getHeaderTextByDomain(this.language);
            return h ? h.text : "";
        },
        mains(): string[] {
            let mains: string[] = [];
            this.action.tiers.forEach(
                t => {
                    let main: Main | undefined = this.action.getMainTextByDomainAndTier(this.language, t.tier);
                    if (undefined !== main) {
                        mains.push(main.text);
                    }
                }
            );
            return mains;
        },
        firstTierText(): string {
            const main: Main | undefined = this.action.getMainTextByDomainAndTier(this.language, 1);
            if (undefined !== main) {
                return main.text;
            }
            return '';
        },
        firstTier(): Tier | undefined {
            return this.action.tiers.find(t => 1 === t.tier);
        },
        nextTier(): Tier | undefined {
            if (undefined !== this.aggregatedAmount) {
                return this.action.getNextTier(this.aggregatedAmount);
            }
            return undefined;
        },
        compactInfo(): string {
            let info: string = '';
            if (this.action.isStandardActionType()) {
                const tier: Tier | undefined = this.firstTier;
                if (tier) {
                    const percentage = 'percentage' === tier.discountType.toLowerCase() ? '%' : '€';
                    info = `${tier.unitDiscount}${percentage}`;
                    if (tier.minAmount > 1) {
                        info += ` (${tier.minAmount})`;
                    }
                }
            }
            return '' !== info ? info : this.header;
        },
        // iconSource(): string {
        //     const config = Util.getConfig();
        //     return `${config.resourcePath}/dist/img/actions/megaphone-grey.svg`;
        // }
    },
    methods: {
        formatPrice: formatPrice,
    },
});
